/** @format */

import React from "react";
import { Container, Row, Col, FormGroup, Label, Input } from "reactstrap";
import { CapabilitiesFormProps } from "../../../Types/Forms.type";

interface PermissionsData {
  name: string;
  label: string;
}

// Group 1: General Pages/Menus
const generalPermissions: PermissionsData[] = [
  { name: "settings", label: "Can Access Settings" },
  { name: "close_register", label: "Can Close Register" },
  { name: "end_day", label: "Can End Day" },
  { name: "products", label: "Can View Products" },
  { name: "addons", label: "Can Manage Addons" },
  { name: "reports", label: "Can Generate Reports" },
  { name: "customers", label: "Can Manage Customers" },
  { name: "cashiers", label: "Can Manage Cashiers" },
  { name: "pay_types", label: "Can Configure Payment Types" },
  { name: "shortcodes", label: "Can Use Shortcodes" },
];

// Group 2: POS Specific
const posPermissions: PermissionsData[] = [
  { name: "quick_edit", label: "Can Perform Quick Edits" },
  { name: "tax_toggle", label: "Can Toggle Tax Settings" },
  { name: "quick_sale", label: "Can Perform Quick Sale" },
];

const PermissionsForm: React.FC<CapabilitiesFormProps> = ({
  formData,
  updateFormData,
}) => {
  const handleSelectAll = (group: PermissionsData[], isChecked: boolean) => {
    group.forEach((perm) => {
      const syntheticEvent = {
        target: {
          name: perm.name,
          type: "checkbox",
          checked: isChecked,
        },
      };
      updateFormData(syntheticEvent as React.ChangeEvent<HTMLInputElement>);
    });
  };

  const isGroupAllSelected = (group: PermissionsData[]) =>
    group.every((perm) => formData.permissions[perm.name]);

  return (
    <Container className="mt-4">
      {/* General Permissions */}
      <h5 className="mb-2">Menu / Page Access</h5>
      <FormGroup check className="mb-3">
        <Label check>
          <Input
            type="checkbox"
            checked={isGroupAllSelected(generalPermissions)}
            onChange={(e) =>
              handleSelectAll(generalPermissions, e.target.checked)
            }
          />
          Select All (Menu / Pages)
        </Label>
      </FormGroup>
      <Row>
        {generalPermissions.map((perm) => (
          <Col md={4} key={perm.name}>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  name={perm.name}
                  checked={formData.permissions[perm.name] || false}
                  onChange={updateFormData}
                />
                {perm.label}
              </Label>
            </FormGroup>
          </Col>
        ))}
      </Row>

      <hr className="my-4" />

      {/* POS Permissions */}
      <h5 className="mb-2">POS Permissions</h5>
      <FormGroup check className="mb-3">
        <Label check>
          <Input
            type="checkbox"
            checked={isGroupAllSelected(posPermissions)}
            onChange={(e) => handleSelectAll(posPermissions, e.target.checked)}
          />
          Select All (POS Permissions)
        </Label>
      </FormGroup>
      <Row>
        {posPermissions.map((perm) => (
          <Col md={4} key={perm.name}>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  name={perm.name}
                  checked={formData.permissions[perm.name] || false}
                  onChange={updateFormData}
                />
                {perm.label}
              </Label>
            </FormGroup>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default PermissionsForm;
